import { Dispatch, useCallback } from 'react';
import { SingleFilter } from '../types';

const useUpdatePotentialFilterForParam = (
  potentialFilters: any,
  setPotentialFilters: Dispatch<any>,
) => {
  const updatePotentialFilterForParam = useCallback(
    (filter: SingleFilter) => {
      if (filter.value) {
        potentialFilters[filter.paramLabel] = filter.value;
      } else {
        delete potentialFilters[filter.paramLabel];
      }
      setPotentialFilters({ ...potentialFilters });
    },
    [potentialFilters],
  );

  return { updatePotentialFilterForParam };
};

export default useUpdatePotentialFilterForParam;
